import { dispatcher } from 'dispatcher';
import { useToggleBalance } from 'js/hooks/user';
import { useUserSelector } from 'js/store/hooks';
import { compose, prop } from 'js/utils/ramda.util';
import React, { useCallback, useEffect } from 'react';
import { Toggle } from 'js/components/common/Fields/Toggle';
import { storageService } from 'js/services/storage.service';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './ToggleBalance.scss';

export const ToggleBalanceBare = () => {
    const toggleBalance = useToggleBalance();
    const translate = useComponentTranslations();
    const isHiddenBalance = useUserSelector(prop('hideBalance'));
    const onChange = useCallback(() => toggleBalance(!isHiddenBalance), [toggleBalance, isHiddenBalance]);

    useEffect(() => {
        // Propagate from React to Backbone
        dispatcher.dispatch('user:toggleBalance');
        // Propagate to listen from admin (e.g. WC, tags)
        publicEventsAPIService.trigger('user:toggleBalance', !isHiddenBalance);
    }, [isHiddenBalance]);

    useEffect(() => {
        const userModelStorageData = storageService.session.getItem('userModel')?.hideBalance;

        toggleBalance(Boolean(userModelStorageData));
    }, [toggleBalance]);

    return (
        <Toggle
            onChange={onChange}
            className={style.toggle}
            checked={!isHiddenBalance}
            classNames={{ toggleMark: style.toggleMark }}
            aria-label={
                translate([
                    'showHideBalance.ariaLabel',
                    'playtech.mobile.system.checkbox.aria-label'
                ])
            }
        />
    );
};

export const ToggleBalance = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.balance.'
    })
)(ToggleBalanceBare);

componentService.registerWebContentComponents({ ToggleBalance });
